/* eslint-disable react/prop-types */
import { useTranslation } from 'react-i18next';
import RoundedButton from '../../../Components/RoundedButton/RoundedButton';
import { OpenDemoLink } from '../../../Components/Utilities/HelperFunctions';

export default function BannerSection() {
  const { t } = useTranslation();
  return (
    <div className="section banner-section">
      <div className="background">
        <p className="section-title">{t('banner-section.section-title')}</p>
        <h2>
          {t('banner-section.multiline-header.0')}
          <br />
          {t('banner-section.multiline-header.1')}
        </h2>
        <p className="section-text">{t('banner-section.section-text')}</p>
        <RoundedButton
          text={t('banner-section.btn-text')}
          fillCyan
          onClick={OpenDemoLink}
        />
      </div>
    </div>
  );
}
